import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { MdaClaim } from "./mda-types";

interface RequestSpreadsheetDialogProps {
  claims: MdaClaim[] | null;
  isCompleting: boolean;
  title?: string;
  onClose: () => void;
  onComplete: () => Promise<void>;
}

const RequestSpreadsheetDialog = ({
  claims,
  isCompleting,
  title = "Complete long running task?",
  onClose,
  onComplete,
}: RequestSpreadsheetDialogProps) => {
  return (
    <Dialog
      open={Boolean(claims)}
      onClose={onClose}
      aria-labelledby="complete-long-running-task-title"
      aria-describedby="complete-long-running-task-description"
    >
      <DialogTitle id="complete-long-running-task-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="complete-long-running-task-description">
          Are you sure you want to request the spreadsheet for{" "}
          <b>{claims?.length} claim(s)</b> and mark them as read?
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 2.5,
          gap: 1,
        }}
      >
        <Button
          onClick={onClose}
          disabled={isCompleting}
          variant="outlined"
          sx={{
            color: "#1769ff",
            borderColor: "#b8d2ff",
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
            px: 2,

            "&:hover": {
              borderColor: "#1769ff",
              bgcolor: "#f5f9ff",
            },
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={onComplete}
          variant="contained"
          disabled={isCompleting}
          startIcon={
            isCompleting ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <DescriptionOutlinedIcon />
            )
          }
          sx={{
            bgcolor: "#1769ff",
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
            px: 2.25,
            boxShadow: "none",

            "&:hover": {
              bgcolor: "#0d5be1",
              boxShadow: "none",
            },
          }}
        >
          {isCompleting ? "Requesting..." : "Request spreadsheet"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequestSpreadsheetDialog;
